import { ACCEPTED_DOCS_TYPES, MAX_FILE_SIZE } from "../../config";
import { FileField, FileInput as RaFileInput, useTranslate } from "react-admin";

import React from "react";

const FileInput = (props) => {
  const translate = useTranslate();
  return (
    <RaFileInput
      {...props}
      multiple={false}
      maxSize={MAX_FILE_SIZE}
      accept={ACCEPTED_DOCS_TYPES.join(",")}
      helperText={translate(
        `resources.${props.resource}.fields.${props.source}.help`,
        { acceptedFormats: ACCEPTED_DOCS_TYPES.join(", ") }
      )}
    >
      <FileField source="filepath" title="filename" />
    </RaFileInput>
  );
};
export default FileInput;
